import { combineReducers } from 'redux';
import { authentication } from './Authentication/reducers';
import * as ArticleReducers from "./Article/reducers";

export default combineReducers({ 
    authentication,
    ...ArticleReducers
})